var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1286C8",
    fillRule: "nonzero",
    d: "M51.213 8.787C45.547 3.12 38.013 0 30 0 21.987 0 14.453 3.12 8.787 8.787 3.12 14.453 0 21.987 0 30c0 8.013 3.12 15.547 8.787 21.213C14.453 56.88 21.987 60 30 60c8.013 0 15.547-3.12 21.213-8.787C56.88 45.547 60 38.013 60 30c0-8.013-3.12-15.547-8.787-21.213zM30 55.153C16.13 55.153 4.847 43.869 4.847 30 4.847 16.13 16.131 4.847 30 4.847c13.87 0 25.153 11.284 25.153 25.153 0 13.87-11.284 25.153-25.153 25.153zm5.744-26.165l-2.916 2.952c-.72.72-1.08 1.836-1.152 2.952a1.815 1.815 0 0 1-1.764 1.332c-.792 0-1.512-.54-1.728-1.332-.072-1.908.576-3.78 1.728-5.112l3.096-3.168c.576-.648.864-1.476.864-2.34 0-2.016-1.62-3.672-3.636-3.672s-3.636 1.656-3.744 4.14c-.18.756-.9 1.296-1.728 1.296A1.767 1.767 0 0 1 23 24.272C23 20.24 26.24 17 30.236 17c3.996 0 7.272 3.24 7.272 7.272 0 1.728-.648 3.384-1.764 4.716zm-5.832 13.14c-.468 0-.9-.18-1.26-.54a1.799 1.799 0 0 1-.504-1.26c0-.468.18-.9.504-1.26.36-.324.792-.504 1.26-.504.468 0 .936.18 1.26.504.36.36.54.792.54 1.26 0 .468-.18.936-.54 1.26-.324.36-.792.54-1.26.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4d02dee033bf1d1077dcafd3ea3845c5.svg";
export { ForwardRef as ReactComponent };